(() => {
  const initProductScroll = (root = document) => {
    root.querySelectorAll('.product-stadium video, .product-scroll-gallery video').forEach((video) => {
      if (video.dataset.productVideoLoopReady === 'true') return;
      video.dataset.productVideoLoopReady = 'true';

      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      const playVideo = () => {
        if (document.visibilityState !== 'visible') return;
        video.play().catch(() => {});
      };

      video.addEventListener('ended', () => {
        video.currentTime = 0;
        playVideo();
      });
      video.addEventListener('canplay', playVideo, { once: true });
      window.addEventListener('pageshow', playVideo);
      document.addEventListener('visibilitychange', playVideo);
      playVideo();
    });

    root.querySelectorAll('.product-layout--scroll').forEach((layout) => {
      if (layout.dataset.productScrollReady === 'true') return;
      layout.dataset.productScrollReady = 'true';

      const lightbox = layout.querySelector('[data-product-lightbox]');
      const lightboxImage = layout.querySelector('[data-product-lightbox-display]');
      const lightboxClose = layout.querySelector('[data-product-lightbox-close]');
      let lightboxTrigger = null;

      if (lightbox && lightbox.parentElement !== document.body) {
        document.body.appendChild(lightbox);
      }

      const closeLightbox = () => {
        if (!lightbox || lightbox.hidden) return;
        lightbox.hidden = true;
        lightboxImage.removeAttribute('src');
        lightboxImage.alt = '';
        document.body.classList.remove('product-image-lightbox-open');
        if (lightboxTrigger) lightboxTrigger.focus({ preventScroll: true });
        lightboxTrigger = null;
      };

      layout.querySelectorAll('[data-product-lightbox-image]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          if (!lightbox || !lightboxImage) return;
          lightboxTrigger = trigger;
          const sourceImage = trigger.querySelector('img');
          lightboxImage.src = trigger.href;
          lightboxImage.alt = sourceImage?.alt || '';
          lightbox.hidden = false;
          document.body.classList.add('product-image-lightbox-open');
          lightboxClose?.focus({ preventScroll: true });
        });
      });

      lightbox?.addEventListener('click', closeLightbox);
      lightboxClose?.addEventListener('click', closeLightbox);
      lightboxImage?.addEventListener('click', closeLightbox);

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox();
      });

    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductScroll());
  } else {
    initProductScroll();
  }

  document.addEventListener('shopify:section:load', (event) => initProductScroll(event.target));
})();
